import { toSentenceCase } from 'src/utils/format-string';

// Keys copied from reffie/models/property_fact.py :: PropertyFactKey
export const PROPERTY_FACT_KEYS = [
    'policy_document_link',
    'pet_policy',
    'listing_link',
    'website',
    'min_income_multiple',
    'is_furnished',
    'income_requirements',
    'tour_times',
    'is_affordable_housing',
    'onsite_team',
    'affordable_housing_income_chart_link',
    'tour_parking',
    'resident_parking',
] as const;

export type PropertyFactKey = typeof PROPERTY_FACT_KEYS[number];

export const PROPERTY_FACT_KEY_LABELS: Record<PropertyFactKey, string> = PROPERTY_FACT_KEYS.reduce<Record<PropertyFactKey, string>>((acc, v: PropertyFactKey) => {
    // hide the "is_" prefix
    let label = v as string;
    if (v.startsWith('is_')) {
        label = v.substring(3);
    }

    acc[v] = toSentenceCase(label.replace(/_/g, ' '));
    return acc;
}, {} as Record<PropertyFactKey, string>);